import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';

import actions from './actions.js';
import getters from './getter.js';
import mutations from './mutations.js';

Vue.use(Vuex);
const state = {
// 用户基本信息
  userInfo: JSON.parse(sessionStorage.getItem('userInfo'))?JSON.parse(sessionStorage.getItem('userInfo')):{status:''},
  screenWidthType:'default',
  search:'',
  dictionary:JSON.parse(sessionStorage.getItem('dictionary'))?JSON.parse(sessionStorage.getItem('dictionary')):'',
  videoToText:false
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});


// WEBPACK FOOTER //
// ./src/store/index.js